import { render, staticRenderFns } from "./dataAnalysis.vue?vue&type=template&id=1f005a50&scoped=true"
import script from "./dataAnalysis.vue?vue&type=script&lang=js"
export * from "./dataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./dataAnalysis.vue?vue&type=style&index=0&id=1f005a50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f005a50",
  null
  
)

export default component.exports